export const EvalYear = ({ value, record }) => record.result?.evalYear;
